export default "__VITE_ASSET__CXj4kpKI__"